import React from "react";
import { Container } from "./styled/form-group";

function FormGroup(props) {
  return <Container {...props} />;
}

export default FormGroup;
